// extracted by mini-css-extract-plugin
export var img__mBHhw = "PlasmicAllTalks-module--img__mBHhw--ecced";
export var img__sy983 = "PlasmicAllTalks-module--img__sy983--e97aa";
export var root = "PlasmicAllTalks-module--root--08e22";
export var talkPreview__hnqXn = "PlasmicAllTalks-module--talkPreview__hnqXn--64c18";
export var talkPreview__vnib = "PlasmicAllTalks-module--talkPreview__vnib--13439";